module.exports = __webpack_public_path__ + "static/media/banner.835c00b3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner.jpeg
// module id = 700
// module chunks = 1